import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useSWR from "swr";
import { OneBtnModal } from "components/common/modal";
import { InquiryInfoTable } from "components/cooperate/detail";
import { PrimaryBtn } from "components/common/button";
import { putCooperate } from "service/api/inquiry";
import { ReactComponent as CheckIcon } from "assets/cooperate/checkIcon.svg";
import type { ICooperateList } from "service/interface/help";
import routerConstant from "service/constant/routerConstant";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function CooperateDetailPage() {
  const params = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<ICooperateList>(
    {} as ICooperateList,
  );
  const [memoValue, setMemoValue] = useState<string>("");
  const [isSuccessModalVisible, setIsSuccessModalVisible] =
    useState<boolean>(false);

  const { data } = useSWR(`/admin/manage/cooperate/${params.id}`);

  useEffect(() => {
    if (data) {
      setDetailData({
        ...data.data,
        memo: data.data.Memos[0]?.content,
      });
      setMemoValue(data.data.Memos[0]?.content);
    }
  }, [data]);

  const handleMemoInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMemoValue(e.target.value);
  };

  const handleSaveBtn = async () => {
    const saveRes = await putCooperate({
      cooperateId: params.id,
      body: {
        status: detailData.status,
        memo: memoValue,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    }
  };

  const handleAnswerBtn = async () => {
    const AnswerRes = await putCooperate({
      cooperateId: params.id,
      body: {
        status: 1,
        memo: detailData.memo,
      },
    });
    if (AnswerRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    }
  };

  const handleSuccesssModalBtn = () => {
    navigate(routerConstant.COOPERATE.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessModalVisible}
        title="저장 완료"
        subTitle="저장 완료되었습니다"
        btnLabel="확인"
        btnClick={handleSuccesssModalBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-gray-4">
              제휴 문의 /{" "}
              {detailData.type && (
                <span className="text-black">
                  {detailData.type === 1
                    ? "제휴 문의 (법인)"
                    : "파트너 문의 (개인)"}
                </span>
              )}
            </p>
            {detailData.status === 0 ? (
              <button
                onClick={handleAnswerBtn}
                className="m-0 flex h-[40px] w-[103px] items-center justify-center gap-[6px] rounded-[8px] border-[1px] border-blue-1 text-[14px] font-semibold text-blue-1"
              >
                <CheckIcon /> 답변 완료
              </button>
            ) : (
              <div className="flex h-[40px] w-[191px] items-center justify-center rounded-[8px] border-[1px] border-[#afafaf] bg-[#f2f2f2]">
                <CheckIcon className="[&>*:nth-child(1)]:[&>*:nth-child(2)]:fill-[#afafaf]" />
                <p className="m-0 text-[14px] font-semibold text-[#afafaf]">
                  이미 답변을 완료했습니다.
                </p>
              </div>
            )}
          </div>
          <div className="mt-[32px] flex flex-col gap-[56px] rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <InquiryInfoTable data={detailData} />
            <div>
              <p className="m-0 mb-[24px] text-[24px] font-semibold text-black">
                메모
              </p>
              <textarea
                value={memoValue}
                onChange={handleMemoInput}
                className="m-0 h-[201px] w-full resize-none rounded-[8px] border-[2px] border-[#e2e2e2] bg-white px-[24px] py-[16px] text-M3 text-gray-5 outline-none focus:border-gray-5 focus:ring-0"
              />
              <div className="mt-[24px] flex justify-end">
                <PrimaryBtn
                  label="저장하기"
                  isDisabled={!memoValue}
                  onClick={handleSaveBtn}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
